import React from 'react';
import trans from '../../translations.json';
import dict from '../../dictionary';
import ReducedData from '../../reducedData.json';
import CompareTable from '../compareTable/compareTable';
import './compareTool.scss';
import { ReactComponent as IconAdd } from '../../ds/icons/svg/ontario-icon-add-alt.svg';

import FuzySearch from '../fuzySearch/fuzySearch';
import SearchResultDropdown from '../search/searchResultDropdown';

const data = Object.keys(ReducedData.dataPHU).reduce(
  (sum, currPHU) => {
    return sum.concat(
      ReducedData.dataPHU[currPHU].cities.map((city) => {
        return {
          city_name: city,
          phu_name:
            dict.PHUs[
              ReducedData.dataPHU[currPHU][dict.Reporting_PHU]
            ],
        };
      }),
    );
  },
  [],
);

const testTimeData = [...ReducedData.dataTesting];

class CompareTool extends React.Component {
  state = {
    searchQuery: '',
    searchResults: [],
    selection: [],
    searchQueryTime: +new Date(),
  };

  onClickSearchResult = (phu_name) => {
    this.props.toggleSelection(phu_name);
    this.setState({
      highlighted: [phu_name],
      searchResults: [],
      searchQuery: phu_name,
      searchQueryTime: +new Date(),
    });
  };

  hideDropdown = () => {
    this.setState({ searchResults: [] });
  };
  searchResultsCallback = (e, results) => {
    this.setState({
      searchResults: results ? results.slice(0, 3) : [],
    });
  };

  setSearchResults = () => {
    setTimeout(
      () =>
        this.setState({
          searchResults: [],
        }),
      200,
    );
  };

  render() {
    const searchOpts = {
      includeMatches: true,
      keys: ['city_name', 'phu_name'],
    };
    return (
      <div className="ontario-alert ontario-alert--informational cviz-compare-tool-container">
        <div className="ontario-alert__header">
          <div className="ontario-alert__header-icon">
            <IconAdd className="cviz-compare-tool-add-icon ontario-icon" />
          </div>
          <div className="ontario-label">
            {trans.testing.compareToolTitle[this.props.lang]}
          </div>
        </div>
        <div className="ontario-alert__body cviz-compare-tool-search-box">
          <FuzySearch
            searchResultsCallback={this.searchResultsCallback}
            data={data}
            searchQueryTime={this.state.searchQueryTime}
            searchQuery={this.state.searchQuery}
            minSearchLength={3}
            searchSettings={searchOpts}
            searchLabel={trans.heatmap.city[this.props.lang]}
            onBlur={this.setSearchResults}
          />
          <SearchResultDropdown
            results={this.state.searchResults}
            handleOnClick={this.onClickSearchResult}
            hideDropdown={this.hideDropdown}
          />
        </div>
      </div>
    );
  }
}

class TimeToProcessTests extends React.Component {
  state = {
    data: undefined,
    columns: undefined,
    selection: [],
  };

  toggleSelectionOfPHU = (name) => {
    let oldSelection = [...this.state.selection];
    this.setState({
      selection: [...oldSelection, name],
    });
  };

  componentDidUpdate(prevProps, prevState) {
    if (this.state.selection !== prevState.selection) {
      this.setData();
    }
  }

  setData = () => {
    let dataFiltered = {};
    testTimeData.forEach((item, z) => {
      let percent_complete_nextday =
        Number(item.percent_complete_nextday_7d_avg) * 100;
      let percent_complete_2days =
        Number(item.percent_complete_2days_7d_avg) * 100;
      let date = item.DATE;

      dataFiltered[item.PHU_name] = {
        index: z,
        name: item.PHU_name,
        date: date,
        percent_complete_nextday: percent_complete_nextday.toFixed(1),
        percent_complete_2days: percent_complete_2days.toFixed(1),
      };
    });

    // console.log('testTimeData', dataFiltered);

    // let sum = Object.values(dataFiltered).reduce(
    //   (sum, curr) => {
    //     sum.in24 += parseFloat(curr.percent_complete_nextday);
    //     sum.in48 += parseFloat(curr.percent_complete_2days);
    //     return sum;
    //   },
    //   { in24: 0, in48: 0 },
    // );
    // let phuSum = Object.values(dataFiltered).length;

    // let averageCompletionRate = {
    //   name: 'Average completion rate',
    //   percent_complete_nextday: (sum.in24 / phuSum).toFixed(1),
    //   percent_complete_2days: (sum.in48 / phuSum).toFixed(1),
    // };

    let averageCompletionRate = {
      name:
        this.props.lang === 'en' ? 'All Ontario' : "Tout l'Ontario",
      percent_complete_nextday:
        dataFiltered['Ontario'].percent_complete_nextday,
      percent_complete_2days:
        dataFiltered['Ontario'].percent_complete_2days,
    };

    this.setState({
      data: [
        averageCompletionRate,
        ...Object.values(dataFiltered).filter((val) => {
          return this.state.selection.includes(val.name);
        }),
      ],
    });
    this.setState({
      columns: [
        {
          title: '',
          dataIndex: 'name',
          key: 'name',
          width: '25%',
          render: (text) => {
            return <b>{text}</b>;
          },
        },
        {
          title: `<h4>${
            trans.testing.in24Hours[this.props.lang]
          }</h4>`,
          subTitle: `<p> <p>`,
          dataIndex: 'percent_complete_nextday',
          key: 'percent_complete_nextday',
          width: '25%',
        },
        {
          title: `<h4>${
            trans.testing.in48Hours[this.props.lang]
          }</h4>`,
          subTitle: `<p>${
            trans.testing.in48HoursDesc[this.props.lang]
          }<p>`,
          dataIndex: 'percent_complete_2days',
          key: 'percent_complete_2days',
          width: '25%',
        },
      ],
    });
  };

  componentDidMount() {
    this.setData();
  }

  removeOnClick = (name) => {
    let oldSelection = [...this.state.selection];
    this.setState({
      selection: oldSelection.filter((item) => item !== name),
    });
  };

  render() {
    return (
      <>
        <p>{trans.testing.descProcessTests[this.props.lang]}</p>
        <CompareTable
          remOnClick={this.removeOnClick}
          data={this.state.data}
          columns={this.state.columns}
        />
        <CompareTool
          lang={this.props.lang}
          toggleSelection={this.toggleSelectionOfPHU}
        />
      </>
    );
  }
}

export default TimeToProcessTests;
